import React, { useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Constants from '@Apis/constants';
import PropTypes from 'prop-types';
import {
  Button,
} from 'antd';
import {
  DownloadOutlined,
} from '@ant-design/icons';
import TenantActions from '@Actions/tenantActions';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import H3FormInput from '@Uilib/h3FormInput';
import './style.scss';

const InstallTally = ({
  user, connectToTally, connectToTallyLoading, history, stepNumber,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [token, setToken] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [connectionUrl, setConnectionUrl] = useState('http://localhost:9000');

  return (
    <Fragment>
      <div className="integration-step__wrapper">
      <header className="integration-step__intro">You are required to install tally plugin in the desktop in which your Tally application is running. Once the plugin is installed, copy the connection token and paste it below to start the activation process.</header>
          <div className="create-tally-btn__download">
            <Button
              type="primary"
              onClick={() => {
                window.location.href = `${Constants.CDN_URL}downloads/procuzy-connect-Setup-0.4.0.exe`;
              }}
              icon={<DownloadOutlined />}
              disabled={connectToTallyLoading}
            >
              Download Plugin
            </Button>
          </div>

          <H3FormInput
              name="connection token"
              type="text"
              label="Please enter the connection token from Tally connector"
              containerClassName="orgInputContainer integration-step-input__wrapper"
              labelClassName="orgFormLabel integration-step-input__label"
              inputClassName="orgFormInput integration-step-input__input"
              placeholder="eg. 6u86shah-wesbhdqf-673nlaufe7c"
              onChange={(value) => {
                setToken(value.target.value);
              }}
              disabled={connectToTallyLoading}
              value={token}
              maxlength="100"
              required
              showError={formSubmitted && token?.length === 0}
            />
            <H3FormInput
              name="Enter Company"
              type="text"
              label="Please enter the company name as per Tally subscription"
              containerClassName="orgInputContainer integration-step-input__wrapper"
              labelClassName="orgFormLabel integration-step-input__label"
              inputClassName="orgFormInput integration-step-input__input"
              placeholder="eg. Moraabh Ventures Private Limited"
              onChange={(value) => {
                setCompanyName(value.target.value);
              }}
              disabled={connectToTallyLoading}
              value={companyName}
              maxlength="100"
              required
              showError={formSubmitted && !companyName}
            />
            <H3FormInput
              name="Enter Port Number"
              type="text"
              label="Please enter Tally connection URL"
              value={connectionUrl}
              containerClassName="orgInputContainer integration-step-input__wrapper"
              labelClassName="orgFormLabel integration-step-input__label"
              inputClassName="orgFormInput integration-step-input__input"
              onChange={(e) => {
                setConnectionUrl(e.target.value);
              }}
              disabled={connectToTallyLoading}
              maxlength="100"
            />
          <div className="ant-row">
            <Button onClick={() => history.push('/admin/integration/')} disabled={connectToTallyLoading} type="primary" ghost>
              Cancel
            </Button>
              &nbsp;
            <Button
              onClick={() => {
                setFormSubmitted(true);
                if (token && companyName) {
                  const payload = {
                    app_token: token,
                    org_id: user?.tenant_info?.org_id,
                    tally_company_name: companyName,
                    tally_server_url: connectionUrl || null,
                  };
                  connectToTally(payload, () => {
                    history.push('/admin/integration/tally');
                  });
                }
              }}
              disabled={connectToTallyLoading}
              type="primary"
            >
              Next
            </Button>
          </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ TenantReducers, UserReducers, TallyIntegrationReducers }) => ({
  tenants: TenantReducers.tenants,
  user: UserReducers.user,
  getLinkedTallyLoading: TallyIntegrationReducers.getLinkedTallyLoading,
  getLinkedTallyta: TallyIntegrationReducers.getLinkedTally,
  connectToTallyLoading: TallyIntegrationReducers.connectToTallyLoading,
  tallyTokenInfo: TallyIntegrationReducers.tallyTokenInfo,
});
const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId, limit, callback, tenantId) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId, limit, callback, tenantId)),

  connectToTally: (payload, callback) => dispatch(
    TallyIntegrationActions.connectToTally(payload, callback),
  ),
  linkTallyWithBusiness: (payload, callback) => dispatch(
    TallyIntegrationActions.linkTallyWithBusiness(payload, callback),
  ),
  getLinkedTally: (orgId, callback) => dispatch(TallyIntegrationActions.getLinkedTally(orgId, callback)),

});
InstallTally.propTypes = {
  user: PropTypes.any,
  connectToTally: PropTypes.any,
  connectToTallyLoading: PropTypes.bool,
  history: PropTypes.any,
  stepNumber: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InstallTally));
